<template>
  <v-dialog v-model="dialog" width="1200" persistent>
    <v-card>
      <v-card-title class="primary py-3 pr-5 fixedTop white--text">
        <span class="title">Customer Existing Services</span>
        <v-btn
          absolute
          top
          right
          fab
          dark
          text
          icon
          small
          style="margin: 27px 0 0 0 !important"
          @click="
            $emit('close');
            reset();
          "
        >
          <v-icon color="white--text">clear</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-flex offset-xs8>
          <vonex-text
            v-model="search"
            :options="fieldConditions"
            name="search"
            hide-details
            solo
            prepend-inner-icon="search"
            clearable
            label="Search"
          ></vonex-text>
        </v-flex>

        <div v-if="serviceType === 'VoIP'">
          <v-data-table
            :headers="headers"
            :items="items.filter((x) => x.type === 'VoIP')"
            :search="search"
            class="elevation-1 mt-3"
            :pagination.sync="pagination"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template v-slot:items="props">
              <td>{{ props.item.type }}</td>
              <td>{{ props.item.extension }}</td>
              <td>{{ props.item.service }}</td>
              <td>{{ props.item.plan }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.added | formatDate }}</td>
              <td>{{ props.item.released | formatDate }}</td>
              <td>{{ props.item.contractEnd | formatDate }}</td>

              <td>
                <vonex-checkbox
                  v-if="props.item.eligible"
                  :input-value="props.item.upgrade"
                  hide-details
                  color="primary"
                  :options="fieldConditions"
                  @change="addSelected(props.item)"
                ></vonex-checkbox>
              </td>
            </template>
          </v-data-table>
        </div>

        <div v-if="serviceType === 'NBN'">
          <v-data-table
            :headers="headers"
            :items="items.filter((x) => x.usageType === 'NBN')"
            :search="search"
            class="elevation-1 mt-3"
            :pagination.sync="pagination"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template v-slot:items="props">
              <td>{{ props.item.customerNumber }}</td>
              <td>{{ props.item.csn }}</td>
              <td>{{ props.item.ratePlanDescription }}</td>
              <td>{{ props.item.contractMonths }}</td>
              <td>{{ props.item.serviceDateAdded | formatDate }}</td>
              <td>{{ props.item.contractEnd | formatDate }}</td>
              <td>
                <vonex-checkbox
                  v-if="props.item.eligible"
                  :input-value="props.item.upgrade"
                  hide-details
                  color="primary"
                  :disabled="isCreateInternet ? props.item.disabled : false"
                  :options="fieldConditions"
                  @input="addSelected(props.item)"
                ></vonex-checkbox>
              </td>
            </template>
          </v-data-table>
        </div>
      </v-card-text>

      <v-card-actions class="pa-3">
        <v-btn class="primary" @click="loadServices">refresh</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="buttonState"
          class="primary"
          @click="
            selectAllItems();
            disable = !disable;
          "
        >
          Select all items (Upgrade)
        </v-btn>

        <v-btn text :disabled="disable" class="primary" @click="emitPayload()">
          {{ buttonText }}
        </v-btn>

        <v-btn
          text
          @click="
            $emit('close');
            reset();
          "
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions: mapIPVoiceActions } =
  createNamespacedHelpers(`orders/ipVoice`);

const { mapActions: mapInternetActions } =
  createNamespacedHelpers(`orders/internet`);

const { mapState: mapOrderState } = createNamespacedHelpers(`orders`);

export default {
  name: 'ExistingServices',
  props: {
    dialog: { type: Boolean },
    account: { type: Number },
    headers: { type: Array },
    serviceType: { type: String },
  },
  data() {
    return {
      rowsPerPageItems: [
        { text: '15', value: 15 },
        { text: '30', value: 30 },
        { text: '45', value: 45 },
        { text: 'All', value: -1 },
      ],
      pagination: {
        rowsPerPage: 15,
      },
      items: [],
      voip: [],
      totalItems: 0,
      search: '',
      disable: true,
      selected: [],
      selectedSoftphone: [],
      showAll: false,
      selectAllDisable: false,
      selectAllSoftphoneDisable: false,
      buttonText: 'Upgrade selected item',
    };
  },
  methods: {
    ...mapIPVoiceActions(['setMessage', 'getServices']),
    ...mapInternetActions(['getInternetUpgrade']),
    loadServices() {
      if (this.account == 0) return;
      let vm = this;

      if (vm.serviceType === 'NBN') {
        if (!vm.rows?.length || !vm.rows[0]?.customerDetails?.ubAccountNo) return;
        
        vm.getInternetUpgrade(vm.rows[0].customerDetails.ubAccountNo).then(
          (data) => {
            if (data && data.length > 0) {
              vm.items = data.filter((x, index, self) =>
                index === self.findIndex(t => t.csn === x.csn && t.ratePlanID === x.ratePlanID)
              );

              if (vm.isCreateInternet) {
                vm.items.forEach((x) => {
                  if (vm.internet.rows.some((y) => y.serviceNumber === x.csn)) {
                    x.disabled = true;
                    x.upgrade = true;
                  } else x.disabled = false;
                });
              }
              
              vm.$emit('loaded', vm.items);
              vm.setMessage({ message: 'Data loaded!', httpStatus: 200 });
            } else {
              vm.setMessage({
                message: 'No Internet services',
                httpStatus: 200,
              });
              vm.items = [];
              return vm.$emit('loaded', []);
            }
          }
        );
      } else {
        vm.getServices(vm.account).then((data) => {
          if (
            data &&
            data.length > 0 &&
            data.some((x) => x.type.toUpperCase() == 'VOIP')
          ) {
            vm.setMessage({ message: 'Data loaded!', httpStatus: 200 });
          } else {
            vm.setMessage({
              message: 'no VoIP  services!',
              httpStatus: 200,
            });
            vm.items = [];
            return vm.$emit('loaded', []);
          }

          if (data.some((x) => x.customerLevelPlan === true)) {
            vm.items = [
              data.filter((x) => x.type.toUpperCase() == 'VOIP').pop(),
            ];
            // vm.items[0].service = 'CustomerPlan';
            vm.items[0].name = 'CustomerPlan';
          } else vm.items = data;
          vm.$emit('loaded', data);
          if (
            vm.items &&
            !vm.items.some(
              (x) =>
                x.type === 'VoIP' &&
                !x.plan.toLowerCase().includes('fax') &&
                !x.released
            )
          ) {
            vm.selectAllDisable = true;
          }
        });
      }
    },
    addSelected(val) {
      val.upgrade = !val.upgrade;
      this.selected = this.items.filter((x) => x.upgrade);
    },
    addSelectedSoftphone() {
      this.selectedSoftphone = this.items.filter((x) => x.addSoftphone);
    },
    emitPayload() {
      this.$emit('close');

      this.selected.forEach((x) => {
        x.disabled = true;

        if (typeof x.name === 'string') {
          x.name = x.name.replace(/\s+/g, ' ').trim();
        }

        if (typeof x.service === 'string') {
          x.service = x.service.replace(/\s+/g, ' ').trim();
        }
      });

      this.$emit('selectedItems', this.selected);
      this.selected = [];
      this.reset();
    },
    isAllowed(item) {
      if (
        !item.plan.toLowerCase().includes('softphone') &&
        !item.plan.toLowerCase().includes('hunt') &&
        !item.released
      )
        return true;
      else return false;
    },
    emitSelectedSoftphonePayload() {
      this.$emit('close');
      this.$emit('selectedSoftphoneItems', this.selectedSoftphone);
      this.selectedSoftphone = [];
      this.reset();
    },
    reset() {
      this.showAll = false;
      this.disable = true;
      this.selectAllSoftphoneDisable = false;
      this.selectAllDisable = false;
      this.items.forEach((x) => {
        x.upgrade = false;
        x.addSoftphone = false;
      });
    },
    selectAllSoftPhoneConferenceItems() {
      let vm = this;
      vm.selectedSoftphone = [];
      vm.items.forEach((x) => {
        if (
          x.type === 'VoIP' &&
          !x.plan.toLowerCase().includes('softphone') &&
          !x.plan.toLowerCase().includes('hunt') &&
          !x.released
        ) {
          x.addSoftphone = 1;
          vm.selectedSoftphone.push(x);
        }
      });

      this.selectAllSoftphoneDisable = true;
    },
    selectAllItems() {
      let vm = this;
      vm.selected = [];

      vm.items.forEach((x) => {
        if (x.eligible && x.usageType && x.usageType === 'NBN' && !x.disabled) {
          x.upgrade = true;
          vm.selected.push(x);
        }

        if (
          x.eligible &&
          x.type === 'VoIP' &&
          !x.plan.toLowerCase().includes('fax') &&
          !x.released
        ) {
          x.upgrade = true;
          vm.selected.push(x);
        }
      });

      vm.selectAllDisable = true;
    },
  },
  computed: {
    ...mapOrderState(['company', 'rows', 'internet']),
    isCreateInternet() {
      let vm = this;
      if (vm.$route.path === '/create-internet') return true;
      else return false;
    },
    buttonState() {
      let vm = this;

      if (vm.isCreateInternet) {
        return vm.selectAllDisable || vm.items.every((x) => x.disabled);
      } else {
        return vm.selectAllDisable;
      }
    },
  },
  watch: {
    selected: function () {
      if (this.selected.length == 0) {
        this.disable = true;
      } else {
        this.disable = false;
      }

      if (this.selected.length > 1) {
        this.buttonText = 'Upgrade selected items';
      } else {
        this.buttonText = 'Upgrade selected item';
      }
    },
  },
  filters: {
    formatDate: function (date) {
      if (!date) return null;
      if (date === '1900-01-01T00:00:00') return '';
      else {
        const [year, month, day] = date.substring(0, 10).split('-');
        return `${day}/${month}/${year}`;
      }
    },
  },
  mounted() {
    this.loadServices();
  },
};
</script>

<style>
.fixedTop {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 999;
}
.invalid {
  background-color: coral;
}
</style>
